export default __webpack_public_path__ + "static/media/wallpaper.31436053.jpg";